import { Injectable } from "@angular/core";
import { RxApiService } from "../../../core/communication/http/rx-api.service";
import { Observable } from "rxjs";
import { ListResponseData } from "../../../core/types";

@Injectable()
export class ReferralService {
    constructor(private rxApi: RxApiService) {}

    list(qs?: any): Observable<ListResponseData<any>> {
        return this.rxApi.get(["referrals"], qs);
    }

    listStatuses(): Observable<any> {
        return this.rxApi.get(["referrals", "statuses"]);
    }

    update(orgId: string, referral: any): Observable<any> {
        return this.rxApi.patch(["referrals", orgId], {}, referral);
    }
}
